import React from 'react';
import styles from '../landing.module.scss';

// Replace with your real logo assets
import studio1Logo from '../../../assets/images/landing/logo-studio-1.png';
import studio2Logo from '../../../assets/images/landing/logo-studio-2.png';
import studio3Logo from '../../../assets/images/landing/logo-studio-3.png';

const TrustedBy = () => {
    return (
        <section className={styles.trustedBySection}>
            <div className={styles.container}>
                <p className={styles.trustedLabel}>Trusted by these brands and more</p>

                <div className={styles.logosGrid}>
                    <div className={styles.logoItem}>
                        <img src={studio1Logo} alt="WOWWY X" />
                    </div>
                    <div className={styles.logoItem}>
                        <img src={studio2Logo} alt="EE FOOTBALL" />
                    </div>
                    <div className={styles.logoItem}>
                        <img src={studio3Logo} alt="IMMM" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustedBy;
